var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vggrid',{attrs:{"list":_vm.list,"tableheight":"400","flexname":"","cols":_vm.pexCols,"showfooter":false,"showPage":false,"resizable":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }